import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { filter, take, map } from 'rxjs/operators';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { State } from '../../reducers';
import { getOneClickUnits } from '../../selectors/one-click-units.selector';
import { OneClickSelectUnitsAction } from '../../actions/one-click-units.actions';

@Injectable()
export class OneClickSyncUnits implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOneClickUnits),
        filter((units) => !!value && !!units.length),
        take(1),
        map((units) => units.find((unit) => unit.alternativeUnit.unitId === value)),
      )
      .subscribe((unit) => {
        if (unit) {
          this.store.dispatch(new OneClickSelectUnitsAction(unit));
        }
      });
  }
}
